export const contactsData = {
    email: 'amanda.jordano@gmail.com',
    //phone: '+915588776600',
    //address: 'Ribeirão Preto, São Paulo, Brazil',
    //sheetAPI: '',
    linkedIn: 'https://www.linkedin.com/in/amandajaquino/',
    github: 'https://github.com/amandajaquino',
}